import React, { useEffect, useState } from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Backdrop, Box, CircularProgress, Grid, Tooltip, Typography } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./custom-datepicker.css"; // Create this file for custom styles
import { getCalandarAttendanceDetails } from "../../testPrepDashboard/Api/DashboardApi";
import Loader from "../../../../SAPPages/components/Loader/Loader";

export default function AttendanceCalendarCard({ student_class_details_id }) {
  const [startDate, setStartDate] = useState(new Date());

  const [calandarAttendanceDetails, setCalandarAttendannceDetails] = useState(
    []
  );
  const [calandarLoading, setCalandarLoading] = useState(false);
  const userId = localStorage.getItem("userId");

  const handlefetchCalandarAttendanceDetails = async (startDate) => {
    setCalandarLoading(true);
    try {
      const response = await getCalandarAttendanceDetails({
        user_id: parseInt(userId),

        student_class_details_id: student_class_details_id,
        date: startDate.toISOString().split("T")[0],
      });

      if (response.status === 200) {
        console.log("response", response?.data);
        setCalandarAttendannceDetails(response?.data);
        setCalandarLoading(false);
      } else {
        setCalandarAttendannceDetails([]);
        setCalandarLoading(false);
      }
    } catch (error) {
      setCalandarAttendannceDetails([]);
      setCalandarLoading(false);
    }
  };

  useEffect(() => {
    handlefetchCalandarAttendanceDetails(startDate);
  }, [startDate]);

  const formatDate = (date) => {
    return date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

  };

  // Only allow dates that have slots
  const filterDate = (date) => {
    const dateStr = formatDate(date);
    const dateObj = calandarAttendanceDetails.find((d) => d.date === dateStr);
    return [0, 1, -1].includes(dateObj?.attendance);
  };



  const customDayClass = (date) => {
    const dateStr = formatDate(date);
    const dateObj = calandarAttendanceDetails.find((d) => d.date === dateStr);

    if (!dateObj) return "";

    switch (dateObj.attendance) {
      case 1:
        return "attend-present";
      case 0:
        return "attend-absent";
      case -1:
        return "attend-leave";
      case null:
        return "attend-null";
      default:
        return "";
    }
  };

  const attendanceStatuses = [
    { label: "Present", color: "#d4edda" },
    { label: "Absent", color: "#f8d7da" },
    { label: "Absent With Permission", color: "#fff3cd" },
  ];

  const renderDayContents = (day, date) => {
    const dateStr = formatDate(date);
    const attendanceRecord = calandarAttendanceDetails.find(
      (d) => d.date === dateStr
    );

    let tooltipText = "";

    switch (attendanceRecord?.attendance) {
      case 1:
        tooltipText = "Present";
        break;
      case 0:
        tooltipText = "Absent";
        break;
      case -1:
        tooltipText = "Absent with permission";
        break;
      case null:
        tooltipText = "No Data";
        break;
      default:
        tooltipText = "";
    }

    return (
      <Tooltip title={tooltipText} arrow>
        <div>{day}</div>
      </Tooltip>
    );
  };

  return (
    <GlobalCard height="100%" padding="10px">
      {" "}
      <Grid container px={1}>
       
        <Grid item xs={12}>
      
          <div className="calendar-container">
            <DatePicker
              selected={startDate}
            
              inline
              filterDate={filterDate}
              dayClassName={customDayClass}
              renderDayContents={renderDayContents}
              calendarStartDay={1} // week starts on Monday
             renderCustomHeader={({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => {
  const getShiftedDate = (baseDate, monthOffset) => {
    const currentDay = baseDate.getDate();
    const targetMonth = baseDate.getMonth() + monthOffset;
    const targetYear = baseDate.getFullYear() + Math.floor(targetMonth / 12);
    const newMonth = (targetMonth + 12) % 12;

    // Ensure day exists in the new month (e.g., Feb 30 → Feb 28)
    const lastDayOfTargetMonth = new Date(targetYear, newMonth + 1, 0).getDate();
    const adjustedDay = Math.min(currentDay, lastDayOfTargetMonth);

    return new Date(targetYear, newMonth, adjustedDay);
  };

  const handlePrev = () => {
    const newDate = getShiftedDate(startDate, -1);
    setStartDate(newDate);
    decreaseMonth(); // optional: updates calendar view
  };

  const handleNext = () => {
    const newDate = getShiftedDate(startDate, 1);
    setStartDate(newDate);
    increaseMonth(); // optional: updates calendar view
  };

  return (
    <div className="custom-header-wrapper">
      <div className="custom-header">
        <span className="month-label">
          <span style={{ width: 44, marginRight: "10px" }}>
            <img src="/newdashboard/Classrom/Attendance/Group 1000016696 (2).png" />
          </span>
          <span>
            {date.toLocaleString("default", { month: "long" })}{" "}
            {date.getFullYear()}
          </span>
        </span>
        <div className="nav-buttons">
          <button onClick={handlePrev} disabled={prevMonthButtonDisabled}>
            <img
              src="/newdashboard/Classrom/Attendance/Group 1000016114.png"
              alt="prev"
            />
          </button>
          <button onClick={handleNext} disabled={nextMonthButtonDisabled}>
            <img
              src="/newdashboard/Classrom/Attendance/Group 1000016117.png"
              alt="next"
            />
          </button>
        </div>
      </div>

      <div className="header-divider" />
    </div>
  );
}}

            />
          </div>
        
        </Grid>

        <Grid
          item
          xs={12}
          mt={1}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          {attendanceStatuses.map((status, index) => (
            <Box key={index} display="flex" alignItems="center" gap={1}>
              <Box height={10} width={10} sx={{ background: status.color }} />
              <Typography
                color="#000000"
                fontFamily="Inter"
                fontSize="12px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                fontWeight={400}
              >
                {status.label}
              </Typography>
            </Box>
          ))}
        </Grid>
       
      </Grid>
    </GlobalCard>
  );
}

 
